/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

import styled from 'styled-components';
import { Button, ButtonGroup } from 'react-bootstrap';

export const ButtonComp = styled(Button)`
  background-color: transparent;
  margin: 0;
  padding: 0;
  &:hover {
    background-color: transparent;
  }
`;

export const ButtonGroupComp = styled(ButtonGroup)`
  margin: 0;
  padding: 1px;
  z-index: 999;
`;
